import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserSessionService } from './usersession.service';
import { DataService } from './data.service';
import { UserSession } from '../models/usersession';

import * as jwtDecode from 'jwt-decode';
import * as momenttz from 'moment-timezone';

import 'rxjs/add/operator/map';
import * as CryptoJS from 'crypto-js';
import { DashboardService } from './dashboard.service';

declare var require: any;
const timezone = require('src/assets/timezones.json');

@Injectable()
export class AuthenticationService {

  private baseUrl = environment.apiBaseUrl;
  timeZones: any[];
  pageAccess = true;
  sessionData = new UserSession();
  tokenFromUI: string = "1e2f3g4c5h7a8x9q";
  tokenFromIV: any;
  role: any;
  menuItems: any[];
  menuItemsClient: any[];

  constructor(
    private http: HttpClient,
    private dataService: DataService,
    private sessionService: UserSessionService,
    private dashboardService: DashboardService,
  ) {
    this.getTimeZones();

  }


  getOtp(email: string, password: string, otpTo: string) {
    const
      data =
      {
        "email": email,
        "password": password,
        "otp_to": otpTo
      }
    return this.http.post<any>(this.baseUrl + '/admin/authenticate', data)
  }


  status(data: any) {
    return this.http.post<any>(this.baseUrl + '/cardholder/cardholder_cardstatus', data)
  }

  verify_otp(data: any) {
    return this.http.post<any>(this.baseUrl + '/gmb/otp/verify', data)
  }


  login(cardNo: any) {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
      });
    const data = { 'cardNo': cardNo };
    return this.http.post<any>(this.baseUrl + '/cardholder/signin', data, { headers })
      .map(user => {
        if (user && user.resultString.authToken) {
          this.clearCachedMenu();
          const decodedToken: any = jwtDecode(user.resultString.authToken);
          this.sessionData.authToken = user.resultString.authToken;
          this.sessionData.cardNo = decodedToken.card_no;
          this.sessionData.cardID = user.cardholderdetails.cardID;
          this.sessionData.profile_type = user.cardholderdetails.profile_type;
          this.sessionData.profile_id = user.cardholderdetails.profile_id;
          this.sessionData.client_id = user.cardholderdetails.client_id;
          this.sessionData.tracking_no = user.cardholderdetails.tracking_no;
          this.sessionData.cardholdername = user.cardholderdetails.cardholdername;
          this.sessionData = this.updateSessionData(user);
          this.sessionService.create(this.sessionData);
        }
        return user;
      });
  }


  getNotification(data: any) {
    return this.http.post<any>(this.baseUrl + '/config/configGetValuesByKeys', data)
  }
  updateSessionData(user: any) {

    let sessionData = new UserSession();
    const decodedToken: any = jwtDecode(user.resultString.authToken);
    sessionData.authToken = user.resultString.authToken;
    this.sessionData.cardNo = decodedToken.card_no;
    this.sessionData.filterresellerId = 1;
    this.sessionData.filterclientId = 0;
    return this.sessionData;
  }

  isAuthenticated() {
    return !!this.sessionService.authToken();
  }

  isPageAccessAvailable(pageUrl, pageTitle) {

    const rolePages = this.sessionService.getLocalStorageWithKey('role') ? this.sessionService.getLocalStorageWithKey('role') : '[]';
    const pages = JSON.parse(rolePages);
    const paths = ['/unauthorized', '/dashboard'];
    if (pages && pages.length > 0) {
      pages.forEach(field => {
        if (field.path) {
          paths.push(field.path);
          paths.push(field.title);
        }
        if (field.submenu && field.submenu.length > 0) {
          field.submenu.forEach(field1 => {
            if (field1.path) {
              paths.push(field1.path);
              paths.push(field1.title);
              if (field1.path === '/servicehosts/1' || field1.path === '/servicehosts/2') {
                paths.push('Test');
              }
              if (field1.path === '/beneficiaries/1' || field1.path === '/beneficiaries/2') {
                paths.push('beneficiaries');
              }
              if (field1.path === '/hosters/1' || field1.path === '/hosters/2') {
                paths.push('Hosters');
              }
            }
          });
        }
      });
      this.pageAccess = (paths.indexOf(pageUrl) >= 0) || (paths.indexOf(pageTitle) >= 0) ? true : false;
    }
    return this.pageAccess;
  }

  hasRequiredPermission(permission) {
    for (let i = 0; i < permission.length; i++) {
      if (permission[i] === this.sessionService.roleId()) {
        return true;
      }

    } return false;
  }

  getTimeZones() {
    this.timeZones = timezone.timeZone;
  }

  getBrowserTimeZone(): string {
    const zoneName = momenttz.tz.guess();
    const temptimezone = momenttz.tz(zoneName).zoneAbbr();
    const filterZone = this.timeZones.find(i => i.abbr === temptimezone);
    if (filterZone) {
      return filterZone.value;
    }
    return '';
  }

  clearCachedMenu() {
    this.dataService.clearCache();
  }

  clearSession() {
    this.sessionService.destroy();
    this.clearCachedMenu();
  }

  logOut() {
    this.clearCachedMenu();
    this.sessionService.destroy();
  }

  forget(email: any) {
    const data = { "email": email }
    return this.http.post<any>(this.baseUrl + '/resetpasswordroute/ResetPassword', data)
  }

  resend(email: string, password: string, otpTo: string, otpLocation: any) {
    const data = { "email": email, "password": password, "otp_to": otpTo, "otp_location": otpLocation }
    return this.http.post<any>(this.baseUrl + '/admin/otp/resend', data)
  }
}
